import { Icon } from "semantic-ui-react";

import React from "react";

import artifactProductionStatuses from "astrid-firestore/src/api/artifacts/constants/artifactProductionStatuses";
import artifactValidationStatuses from "astrid-firestore/src/api/artifacts/constants/artifactValidationStatuses";

import themeColors from "../../../ui/constants/themeColors";

import useArtifactContentType from "../../hooks/useArtifactContentType";
import getArtifactProductionStatus from "../../utils/getArtifactProductionStatus";

export default function ArtfactIcon({ artifact, selected, size = 18 }) {
	const { icon } = useArtifactContentType({ artifact });

	const status = getArtifactProductionStatus({ artifact });

	const active = typeof selected === "boolean" ? selected : status === artifactProductionStatuses.DELIVERED;

	const invalid = [artifactValidationStatuses.FAILED, artifactValidationStatuses.INVALID].includes(
		artifact?.status,
	);

	const color = invalid ? themeColors.RED : active ? themeColors.GREEN : themeColors.GREY;
	const background = invalid ? "rgba(255, 74, 61, 0.15)" : active ? "rgba(0, 211, 87, 0.15)" : "rgba(0, 0, 0, 0.15)";

	return (
		<Icon
			inverted
			name={icon}
			style={{
				width: "2em",
				height: "2em",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				opacity: invalid ? 1 : active ? 1 : 0.5,
				fontSize: size,
				borderRadius: 5,
				background,
				color,
			}}
		/>
	);
}
